import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetAlgorithmsCitiesRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Algorithms/GetAlgorithmsCities`,
	params: { userId }
});

export const GetAlgorithmsDatesRequest = (city) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Algorithms/GetAlgorithmsDates`,
	params: { city }
});

export const RunOvershootingByCoordinatesRequest = (
	userId, city, date, points, tech2g, tech3g, tech4g,
	osParameters2g, osParameters3g, osParameters4g
) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Algorithms/RunOvershootingByCoordinates`,
	data: { userId, city, date, points, tech2g, tech3g, tech4g, osParameters2g, osParameters3g, osParameters4g }
});

export const RunOvershootingByFileRequest = (
	userId, city, date, filePath, tech2g, tech3g, tech4g,
	osParameters2g, osParameters3g, osParameters4g
) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Algorithms/RunOvershootingByFile`,
	data: { userId, city, date, filePath, tech2g, tech3g, tech4g, osParameters2g, osParameters3g, osParameters4g }
});
